import classNames from 'classnames';
import {FC, useCallback} from 'react';

import {Icon} from 'components/Icon/Icon';
import {Text} from 'components/Text/Text';

import styles from './Counter.module.css';

type Props = {
    className?: string;
    onChange: (value: number) => void;
    value: number;
    minValue?: number;
    // по сколько за раз нужно прибавлять/отнимать
    step?: number;
    readonly?: boolean;
};
export const Counter: FC<Props> = ({
    className,
    value,
    step,
    minValue,
    readonly = false,
    onChange,
}) => {
    const handleAdd = useCallback(() => {
        const newValue = value + (step || 1);
        onChange(newValue);
    }, [onChange, step, value]);

    const handleSubstract = useCallback(() => {
        const newValue = value - (step || 1);
        if (newValue < (minValue || 1)) {
            return;
        }

        onChange(newValue);
    }, [onChange, step, value, minValue]);

    if (readonly) {
        return (
            <div
                className={classNames(styles.block, className, {
                    [styles.readonly]: readonly,
                })}
            >
                <Text.Bold14 className={styles.count}>{value}</Text.Bold14>
            </div>
        );
    }

    return (
        <div className={classNames(styles.block, className)}>
            <Icon
                name="minus"
                className={classNames(styles.icon, {
                    [styles.disabled]: value === (minValue || 1),
                })}
                onClick={handleSubstract}
            />
            <Text.Bold14 className={styles.count}>{value}</Text.Bold14>
            <Icon name="plus12" className={styles.icon} onClick={handleAdd} />
        </div>
    );
};
